function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import IMask from 'imask';
import omit from 'ramda/src/omit';
import always from 'ramda/src/always';
import ifElse from 'ramda/src/ifElse';
import propOr from 'ramda/src/propOr';
export var createMasker = (pattern, options) => {
  var masked = _objectSpread({
    mask: pattern
  }, omit(['unmask'], options !== null && options !== void 0 ? options : {}));

  var unmaskedOrTypedValue = ifElse(propOr(true, 'unmask'), always(IMask.PIPE_TYPE.UNMASKED), always(IMask.PIPE_TYPE.TYPED));
  var handleMask = IMask.createPipe(masked, unmaskedOrTypedValue(options), IMask.PIPE_TYPE.MASKED);
  var handleUnmask = IMask.createPipe(masked, IMask.PIPE_TYPE.MASKED, unmaskedOrTypedValue(options));
  return {
    mask: handleMask,
    unmask: handleUnmask
  };
};
//# sourceMappingURL=createMasker.js.map